import Header from '../components/Header';
import ApiKeysPanel from '../components/ApiKeysPanel';
import PricingPlayground from '../components/PricingPlayground';
import QuickStart from '../components/QuickStart';

export default function Dashboard() {
  return (
    <div className="min-h-screen bg-[#fafafa]">
      <Header />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 pt-24 pb-12">
        {/* Page header */}
        <div className="mb-8">
          <h1 className="text-2xl font-semibold text-[#0a0a0a]">Dashboard</h1>
          <p className="text-[#737373] mt-1">Manage your API keys and test pricing endpoints</p>
        </div>
        
        <div className="grid lg:grid-cols-3 gap-6">
          {/* Sidebar */}
          <div className="lg:col-span-1 space-y-6">
            <ApiKeysPanel />
            <QuickStart />
          </div>
          
          {/* Main content */}
          <div className="lg:col-span-2">
            <PricingPlayground />
          </div>
        </div>
      </main>
      
      {/* Footer */}
      <footer className="border-t border-[#e5e5e5] py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex justify-between items-center">
          <p className="text-sm text-[#a3a3a3]">© 2025 Quantra. Built with QuantLib.</p>
          <div className="flex gap-6">
            <a href="https://quantra.io/docs" className="text-sm text-[#737373] hover:text-[#0a0a0a] transition-colors">Docs</a>
            <a href="https://github.com/joseprupi/quantraserver" className="text-sm text-[#737373] hover:text-[#0a0a0a] transition-colors">GitHub</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
